// Einstellungen → Mein Konto (Phase 3): Abwesenheit mit Vertretung, Bob-Hintergrund-Vorschläge.
import { useEffect, useState } from 'react';
import { TEAM, isUserKey } from '@mail/shared';
import { api, type Konto } from '../lib/api.ts';
import { useStore } from '../lib/store.ts';
import { toast } from './Toast.tsx';

export function KontoSettings() {
  const me = useStore((s) => s.me);
  const [data, setData] = useState<Konto | null>(null);
  const [bis, setBis] = useState('');
  const [notiz, setNotiz] = useState('');
  const [vertretung, setVertretung] = useState('');
  const [vorschlaege, setVorschlaege] = useState(false);
  const load = () =>
    void api.konto().then((k) => {
      setData(k);
      setBis(k.konto?.absentUntil ? k.konto.absentUntil.slice(0, 10) : '');
      setNotiz(k.konto?.absentNote ?? '');
      setVertretung(k.konto?.substitute ?? '');
      setVorschlaege(!!k.konto?.bobVorschlaege);
    });
  useEffect(load, []);
  const save = async () => {
    try {
      await api.kontoSpeichern({
        absentUntil: bis ? new Date(bis + 'T23:59:59').toISOString() : null,
        absentNote: notiz || null,
        substitute: (vertretung || null) as 'till' | 'lars' | 'maren' | null,
        bobVorschlaege: vorschlaege,
      });
      toast('Gespeichert');
      load();
    } catch (e) {
      toast((e as Error).message);
    }
  };
  if (!data) return null;
  const abwesend = data.team.filter((t) => t.abwesend && t.key !== me?.key);
  return (
    <div className="s-snip" style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <div>
        <b>Abwesenheit mit Vertretung.</b> Solange du abwesend bist, wandern deine zugewiesenen
        offenen Threads mit Notiz zur Vertretung (geprüft alle 10 Minuten). Auch ein Flow-Termin mit
        „Urlaub“ oder „abwesend“ im Titel zählt, wenn eine Vertretung eingetragen ist.
      </div>
      <div className="konto-row">
        <label>
          abwesend bis
          <input type="date" value={bis} onChange={(e) => setBis(e.target.value)} />
        </label>
        <label>
          Vertretung
          <select value={vertretung} onChange={(e) => setVertretung(e.target.value)}>
            <option value="">– keine –</option>
            {data.team
              .filter((t) => t.key !== me?.key)
              .map((t) => (
                <option key={t.key} value={t.key}>
                  {t.name}
                </option>
              ))}
          </select>
        </label>
        <label style={{ flex: 1 }}>
          Hinweis
          <input
            value={notiz}
            onChange={(e) => setNotiz(e.target.value)}
            placeholder="z. B. Urlaub, erreichbar per Handy"
          />
        </label>
      </div>
      <label style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={vorschlaege}
          onChange={(e) => setVorschlaege(e.target.checked)}
        />
        <span>
          <b>Bob darf Hintergrund-Vorschläge vorbereiten:</b> Bei neuen Routinefragen liegt beim
          Öffnen ein Entwurf bereit (markiert als „Vorschlag“, Kosten auf Bobs Monatsdeckel).
        </span>
      </label>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <button className="btn sm pri" onClick={() => void save()}>
          Speichern
        </button>
        {abwesend.length > 0 && (
          <span className="muted" style={{ fontSize: 12 }}>
            Gerade abwesend:{' '}
            {abwesend
              .map(
                (t) =>
                  `${t.name}${t.bis ? ` bis ${new Date(t.bis).toLocaleDateString('de-DE')}` : ''}${t.vertretung && isUserKey(t.vertretung) ? ` (Vertretung ${TEAM[t.vertretung].name})` : ''}`,
              )
              .join(', ')}
          </span>
        )}
      </div>
    </div>
  );
}
